import z from 'zod'

export type SigninEmailValidateObject = z.infer<
  typeof signinEmailValidateObject
>
export type SigninPasswordValidateObject = z.infer<
  typeof signinPasswordValidateObject
>

export const signinEmailValidateObject = z.object({
  email: z
    .string()
    .min(0, { message: '入力してください' })
    .email({ message: 'メールアドレスの形式が正しくありません' }),
})

export const signinPasswordValidateObject = z.object({
  password: z.string().min(0, { message: '入力してください' }),
})
